export default function LoginReminder() {
    const openAuthLock = () => {
        setTimeout(() => {
            window.auth.lock.showLock();
          }, 500)
    }
    return <div className="flex flex-col w-[90vw] mt-5 border-[1px] rounded-lg text-left border-slate-300 shadow-sm lg:w-[60vw]">
        <h1 className="h-1/6 bg-[#E6A733] text-white p-2 text-sm">
            A LOGIN IS REQUIRED TO ACCESS METRICS
        </h1>
        <p className="p-4">
            This page requires authentication, please <span className="inline-block cursor-pointer underline underline-offset-1" onClick={openAuthLock}>login</span> with your credentials and access to valuable insights once you are authenticated.
        </p>
    </div>
}